// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"uq-z","breadcrumbForward":"vq-z","breadcrumbBack":"wq-z","selected":"xq-z"};